import React from "react";
import LinkedAssets from "./linkedAssets/linkedAssets"
import { ProjectsAssetsStyled } from "./projects-assets.style";


const ProjectAssets = ({ linkedAssets, handleDeleteLink }) => {

  return (
    <ProjectsAssetsStyled>

    <div className="linked-project-assets">
        <LinkedAssets linkedAssets={linkedAssets} handleDeleteLink={handleDeleteLink}/>
    </div>

    </ProjectsAssetsStyled>
  );
};

export default ProjectAssets;
